import { useState } from 'react';
import { JobsDrawer } from './JobsDrawer';
import { JobsTrigger } from './JobsTrigger';

export function JobsSidebar() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <JobsTrigger open={open} onClick={() => setOpen((o) => !o)} />
      <JobsDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
